module.exports = __webpack_public_path__ + "kr.ed1449e8348355647681.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/kr.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/kr.svg
// module chunks = styles